import { startOfMinute, endOfMinute, isToday, startOfDay, endOfDay, subDays, isBefore } from 'date-fns';
import { getEventDescription } from '#component/warehouse/warehouse-log/helper';
import { warehouseEventType } from '#type';

const formatLog = log => {
  const { event } = log;
  const eventId = event?.id;
  const timestamp =
    warehouseEventType.TRIGGER_APPLIANCE_GROUP_ALERT === eventId && log.messageTimestamp ?
      log.messageTimestamp : log.timestamp;
  return {
    details: log,
    timestamp: `${timestamp}`,
    description: getEventDescription(log, '', true),
    identifier: `appliance_${event?.id}`,
    eventId
  };
};

export const mergeEvents = events =>
  events
    .reduce((a, c) => {
      const isDeviceEvent = Object.prototype.hasOwnProperty.call(c, 'id');
      if (isDeviceEvent) {
        let deviceEvents = c.events ?? [];
        if (c.eventsChunks) {
          deviceEvents = c.eventsChunks.flat();
        }
        a.push(...deviceEvents);
      } else {
        a.push(formatLog(c));
      }

      return a;
    }, [])
    .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp))
    .reverse();

export const getAvailableDateRange = (creationDate, endDate, subtractedDays) => {
  const creation = new Date(creationDate);
  const end = new Date(endDate);
  const subtractedEnd = subDays(end, subtractedDays);
  const ofEnd = isToday(end) ? endOfMinute : endOfDay;

  // Check if the subtracted end date is before the creation date
  if (isBefore(subtractedEnd, creation)) {
    return {
      start: startOfMinute(creation).toISOString(),
      end: ofEnd(end).toISOString()
    };
  }

  return {
    start: startOfDay(subtractedEnd).toISOString(),
    end: ofEnd(end).toISOString()
  };
};
